import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  selectRoot: {
    fontSize: 13,
    fontWeight: 400,
  },
}))
const INITIAL_VAL = '--- Click to select ---'

const VariantPickerWidget = props => {
  const { t } = useTranslation()
  const { values, attributeKey, selected, onChangeSelected, selection, matchVariantFromSelection } = props
  const classes = useStyles()

  const isInitial = selected === INITIAL_VAL || (!selected && values.length > 1)

  const variantAvailability = val => {
    const attrs = { ...selection, [attributeKey]: val }
    const matchedVariant = matchVariantFromSelection(attrs)
    if (!matchedVariant || !matchedVariant.shippingRequired) return null
    let status = null
    if (matchedVariant.outOfStockStatus === 'BACKORDER' && !matchedVariant.stockQuantity) {
      status = <span className='stock-status dynamic yellow ml-5'>{t('productBackorder', 'Backorder')}</span>
    } else if (matchedVariant.outOfStockStatus === 'OUT' && !matchedVariant.stockQuantity) {
      status = <span className='stock-status dynamic red ml-5'>{t('productOutOfStock', 'Out of Stock')}</span>
    }
    return status
  }
  const initialSelected = values.length > 1 ? INITIAL_VAL : values[0]
  return (
    <div>
      <FormControl className={isInitial ? 'error' : ''} variant='outlined' margin='none' fullWidth required>
        <label className='font-semibold' htmlFor={`label${attributeKey}`}>
          {attributeKey}
        </label>
        <Select
          labelId={`label${attributeKey}`}
          id='select'
          value={selected || initialSelected}
          onChange={e => {
            onChangeSelected(attributeKey, e.target.value)
          }}
          className={`${values.length === 1 ? 'no-events' : ''}`}
          classes={{ root: classes.selectRoot } as any}
          MenuProps={{
            variant: 'menu',
            className: 'variant-picker-menu',
            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            transformOrigin: { vertical: 'top', horizontal: 'right' },
            keepMounted: true,
          }}
        >
          {values.length > 1 && (
            <MenuItem key='click-select' className={`variant-picker-widget__item required-color`} value={INITIAL_VAL}>
              {t('formOptions.clickToSelect', '--- Click to select ---')}
            </MenuItem>
          )}
          {values.map(val => (
            <MenuItem
              key={val}
              className={`variant-picker-widget__item ${isInitial ? 'required-color' : ''}`}
              value={val}
            >
              {val}
              {variantAvailability(val)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}
export default React.memo(VariantPickerWidget)
